// Samoony brand mark (smile + signal dot) and wordmark.
// Inline SVG so it inherits currentColor and renders crisp at every size.

export function Mark({ size = 24, dotColor, strokeColor, ...rest }) {
    const s = typeof size === "number" ? `${size}px` : size;
    return (
        <svg
            width={s}
            height={s}
            viewBox="0 0 26 26"
            role="img"
            aria-label="Samoony mark"
            {...rest}
        >
            <circle cx="13" cy="6" r="3" fill={dotColor || "#FF2E7E"} />
            <path
                d="M5 12 a8 8 0 0 0 16 0"
                fill="none"
                stroke={strokeColor || "currentColor"}
                strokeWidth="3.2"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function Wordmark({ height = 28, className = "", ...rest }) {
    return (
        <span
            className={`inline-flex items-center gap-2 ${className}`}
            {...rest}
        >
            <Mark size={height} />
            <span
                className="font-display font-extrabold leading-none text-ink"
                style={{
                    fontSize: `${height * 0.78}px`,
                    letterSpacing: "-0.02em",
                }}
            >
                samoony
            </span>
        </span>
    );
}

export function BrandLink({ to = "/", height = 28, className = "" }) {
    // Lazy import of Link to avoid pulling react-router into pure markup contexts.
    const Link = require("react-router-dom").Link;
    return (
        <Link to={to} className={`inline-flex items-center gap-2 no-underline ${className}`}>
            <Wordmark height={height} />
        </Link>
    );
}
